/*
 * Privacyverklaring. Tekst letterlijk uit legacy/current/privacy.html (FR-23).
 *
 * De bestaande site zegt zelf dat dit een concepttekst is; O-05 levert de
 * definitieve verklaring. Die moet ook de verwerkers uit ADR-0004 en de
 * bewaartermijn uit ADR-0007 benoemen.
 */
export default function Privacy() {
  return (
    <>
      <div className="page-head">
        <div className="wrap">
          <span className="eyebrow">Privacy</span>
          <h1>Privacyverklaring</h1>
          <p className="lede">
            Concepttekst. De definitieve privacyverklaring wordt juridisch
            opgesteld en gereviewd (zie requirements O-05).
          </p>
        </div>
      </div>
      <section className="section" style={{ paddingTop: '36px' }}>
        <div className="wrap">
          <div className="prose">
            <p>
              GPKeuringen gaat zorgvuldig om met uw persoonsgegevens. Wij vragen
              alleen de gegevens die nodig zijn voor uw aanvraag en de afspraak
              (dataminimalisatie: wij vragen géén BSN en géén uitgebreide
              medische gegevens via het formulier).
            </p>
            <p>
              Uw gegevens worden versleuteld verstuurd (TLS) en niet gedeeld met
              anderen zonder uw toestemming. Wij gebruiken geen
              tracking-cookies.
            </p>
            <p>
              In de definitieve verklaring worden onder meer benoemd: de
              verwerkte gegevens, doeleinden en grondslagen, bewaartermijnen, de
              ingeschakelde verwerkers (betaalprovider, agenda- en
              e-maildiensten, hosting) en uw rechten (inzage, correctie,
              verwijdering).
            </p>
          </div>
        </div>
      </section>
    </>
  )
}
